import React from 'react';
import { styled } from 'styled-components';
import { OrderType } from '@dazzle/api-client';

import { DeviceQueries } from 'Common/components/styled';

import {
  CONCIERGE_ALL,
  CONCIERGE_UNASSIGNED,
  OrderStatusFilter,
  OrderStatusFilterNames,
  OrderTypeFilterNames,
  useOrdersContext
} from 'Compass/contexts/OrdersContext';
import { StyledSelect } from 'Compass/components/styled/Select';


const OrderFilters = () => {
  const ordersContext = useOrdersContext();

  return <FilterBar>
    <FilterGroup>
      {
        Object.values(OrderStatusFilter).map(orderStatus => <FilterText
          key={orderStatus}
          $active={ordersContext.orderStatusFilter === orderStatus}
          onClick={() => ordersContext.setOrderStatusFilter(orderStatus)}
        >
          {OrderStatusFilterNames[orderStatus]}
        </FilterText>)
      }
    </FilterGroup>
    <FilterDivider/>
    <FilterGroup>
      {
        Object.values(OrderType).map(orderType => <FilterText
          key={orderType}
          $active={ordersContext.orderTypeFilter === orderType}
          onClick={() => ordersContext.setOrderTypeFilter(orderType)}
        >
          {OrderTypeFilterNames[orderType]}
        </FilterText>)
      }
    </FilterGroup>
    <FilterDivider/>
    <FilterGroup>
      <FilterLabel>
        Concierge
      </FilterLabel>
      <FilterInput>
        <StyledSelect
          onChange={(e) => ordersContext.setConciergeFilter(e.currentTarget.value)}
          defaultValue={ordersContext.conciergeFilter}
        >
          <option value={CONCIERGE_ALL}>
            - All -
          </option>
          <option value={CONCIERGE_UNASSIGNED}>
            - Unassigned -
          </option>
          {
            ordersContext.concierges.map(concierge => <option
              key={concierge.email}
              value={concierge.email}
            >
              {concierge.name}
            </option>)
          }
        </StyledSelect>
      </FilterInput>
    </FilterGroup>
  </FilterBar>
};

const FilterBar = styled.div`
  display: flex;
  gap: 12px;
  background: #F8F9FC;
  padding: 14px 20px;
  border: 1px solid #E4E7EF;
  border-radius: 12px;
  margin-bottom: 16px;

  @media (${DeviceQueries.mobile}) {
    flex-direction: column;
  }
`;

const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FilterDivider = styled.div`
  background-color: #E4E7EF;
  @media (${DeviceQueries.mobile}) {
    height: 1px;
  }
  @media not (${DeviceQueries.mobile}) {
    width: 1px;
  }
`;

const FilterText = styled.div<{$active: boolean}>`
  font-size: 13px;
  padding: 5px 12px;
  border-radius: 8px;
  transition: all 0.15s ease;
  ${({$active}) => $active
    ? 'font-weight: 600; color: #008AFF; background: rgba(0, 138, 255, 0.08);'
    : 'cursor: pointer; color: #5A6178; &:hover { color: #1A1D2B; background: rgba(0, 0, 0, 0.03); }'}
`;

const FilterLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: #5A6178;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const FilterInput = styled.div`
  select {
    background: white;
    border: 1px solid #E4E7EF;
    border-radius: 8px;
    padding: 7px 12px;
    font-size: 13px;
    color: #1A1D2B;
    transition: border-color 0.15s ease;

    &:hover {
      border-color: #CDD1DC;
    }

    &:focus {
      outline: none;
      border-color: #008AFF;
      box-shadow: 0 0 0 3px rgba(0, 138, 255, 0.1);
    }
  }
`;

export default OrderFilters;
